module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Canadian Girl in South Africa")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle-pre"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/06_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/09_A_Africa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A CANADIAN GIRL IN SOUTH AFRICA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER I | The Call to South Africa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER II | London")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER III | Southampton to Cape Town")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER IV | On the Karoo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER V | Norval’s Pont Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VI | Johannesburg and Pretoria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VII | End of the Camp Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VIII | Fauresmith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER IX | Kroonstad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER X | The Kafirs and the Labor Question")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XI | Repatriation and Compensation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XII | Paupers and Government Relief Works")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XIII | Education and Church Schools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XIV | The Farming Question")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XV | Homewards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-888106a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Contents.vue
// module id = 63
// module chunks = 0